<div class="cw-module">
    <!-- Header -->
    <div class="cw-flex-row cw-list-toolbar">
        <!-- Selectbox für Datenquelle -->
        <phscw-grid-source
            [gridId]="gridId"
            [gridSources]="gridSources"
            [gridConnection]="gridInstitutionsList"
            [currentSource]="initialSource">
        </phscw-grid-source>

        <!-- Selectbox für Layout -->
        <phscw-grid-layout
            [gridId]="gridId"
            [gridLayouts]="gridLayouts"
            [gridConnection]="gridInstitutionsList"
            [currentLayout]="initialLayout">
        </phscw-grid-layout>

        <!-- Toolbar für Fullscreen-Button -->
        <phscw-toolbar
            componentIdentifier="institutionsList"
            [componentConnection]="$any(this)"
            [buttonFullscreen]="true"
            [leftAlign]="true">
        </phscw-toolbar>

        <!-- Toolbar -->
        <phscw-toolbar
            componentIdentifier="institutionsList"
            [componentConnection]="$any(this)"
            [buttonMerge]="true"
            [buttonMergeParameter]="{disabled: checkedInstitutions.length !== 2}"
            [buttonAdd]="permissionAllowNewInstitution"
            [buttonAddShadow]="permissionAllowNewShadowInstitution"
            [buttonAddParameter]="$any({disabled: !allowNewInstitution})"
            buttonAddTooltip="{{ 'MODULES.INSTITUTIONS.LIST.ADDNEW' | translate }}"
            [buttonDelete]="allowDeleteInstitution"
            buttonDeleteTooltip="{{ 'MODULES.INSTITUTIONS.LIST.DELETEINSTITUTION' | translate }}"
            [buttonGridSort]="true"
            [buttonGridFilter]="false"
            [buttonGridSelection]="true"
            [buttonHierarchy]="allowChangeHierarchy"
            [buttonIgnoreHierarchyParameter]="ignoreHierarchy"
            [buttonLoadAll]="allowLoadAll"
            [buttonLoadAllParameter]="loadAll"
            [buttonGridColumns]="true"
            [buttonExcel]="true"
            [buttonLargeExcel]="true"
            [buttonScheduling]="enableScheduling"
            [buttonSchedulingParameter]="!(checkedInstitutions.length > 0)"
            [buttonCharacteristics]="characteristicsPopupEnabled"
            [buttonCharacteristicsParameter]="{disabled: checkedInstitutions.length <= 0}"
            [buttonAi]="enableMcpAiSelectionsButton"
            [buttonImport]="enableImportButton ? 'institutions' : false"
            [buttonToolbarMenu]="true"            >
        </phscw-toolbar>
    </div>

    <!-- Grid-Extensions -->
    <!-- Grid-Sort -->
    <phscw-grid-sort
        [gridId]="gridId"
        [gridConnection]="gridInstitutionsList"
        [visible]="gridExtensionsVisibility.sort"
        [sortFields]="gridSortFields">
    </phscw-grid-sort>

    <!-- Grid-Filter -->
    <phscw-grid-filter
        [gridId]="gridId"
        [gridConnection]="gridInstitutionsList"
        [visible]="gridExtensionsVisibility.filter">
    </phscw-grid-filter>

    <!-- Grid-Selektion -->
    <phscw-grid-selection-panel
        gridId="institutionsList"
        [gridConnection]="gridInstitutionsList"
        [visible]="gridExtensionsVisibility.selection"
        [frontendArray]="gridFrontendArray"
        [transferArray]="gridTransferArray">
    </phscw-grid-selection-panel>

    <!-- Grid-Columns -->
    <phscw-grid-columns-panel
        gridId="institutionsList"
        [gridConnection]="gridInstitutionsList"
        [visible]="gridExtensionsVisibility.columns"
        [allColumns]="gridAllColumns">
    </phscw-grid-columns-panel>
    <phscw-grid-mcp-selections [aiActive]="aiActive">
    </phscw-grid-mcp-selections>

    <!-- Grid -->
    <phscw-grid
        #gridInstitutionsList
        [gridId]="gridId"
        gridBackendSource="InstitutionsList/index"
        [gridColumns]="gridColumns"
        [gridDisplayedColumns]="gridDisplayedColumns"
        [gridRegionsFilter]="gridRegionsFilter"
        [listInitialized]="initialized"
        [selectableLayouts]="true"
        [useInstitutionsIcons]="true"
        [usePeopleIcons]="true"
        [sortableHeader]="true"
        [sortBackend]="true"
        [enableResize]="true"
        [optionalBackendValues]="{
            ignoreHierarchy: ignoreHierarchy,
            loadAll: loadAll
        }">
    </phscw-grid>
</div>
